import script from "./VerificationRequiredSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerificationRequiredSheet.vue?vue&type=script&setup=true&lang=ts"

import "./VerificationRequiredSheet.vue?vue&type=style&index=0&id=3432dea3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3432dea3"]])

export default __exports__